export const NETWORK_MAP = {
  "0x1": { name: "Eth mainnet" },
  "0x3": { name: "Ropsten" },
  "0x4": { name: "Rinkeby" },
  "0x5": { name: "Goerli" },
  "0x2a": { name: "Kovan" },
  "0x38": { name: "Bsc mainnet" },
  "0x61": { name: "Bsc testnet" },
  "0x89": { name: "Matic main" },
  "0x13881": { name: "Polygon" },
  "0xa86a": { name: "Avalanche Mainnet" },
  "0xa869": { name: "Avalanche test" },
  "0xfa": { name: "Fantom Mainnet" },
};

export const CURRENCIES = {
  "0x4": {
    wETH: "0xc778417E063141139Fce010982780140Aa0cD5Ab",
    MTK: "0x511A0A2213550297B0F13E7A9Ba832d6a6f8D135",
  },
  "0x13881": {
    Matic: "0x0000000000000000000000000000000000001010",
    MTK: "0x2B81747847dB3c811AC5370d3E99D2863DEA83A5",
  },
  "0x61": {
    BNB: "0xDB73Dde1867843FDCA5244258F2Fd4B6DC7B154e",
    MTK: "0x9AB3AB5e439A260d35dd9907963CB76F038Eb945",
  },
};

export const BLOCK_SCANNER = {
  "0x4": "rinkeby.etherscan.io",
  "0x13881": "mumbai.polygonscan.com",
  "0x61": "testnet.bscscan.com",
};

export const APP_VERSION = '3.1.0';

export const ENABLE_REDUX_DEV_TOOLS = false;

export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK',
  UNICORN: 'UNICORN'
};

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export const EMPTY_DATA = '0x';
export const SALT = Date.now();

const features = {
  ERC721: "ERC721",
  SAFE_APPS: "SAFE_APPS",
  CONTRACT_INTERACTION: "CONTRACT_INTERACTION",
  DOMAIN_LOOKUP: "DOMAIN_LOOKUP",
  SPENDING_LIMIT: "SPENDING_LIMIT",
  EIP1559: "EIP1559",
  SAFE_TX_GAS_OPTIONAL: "SAFE_TX_GAS_OPTIONAL"
};
Object.freeze(features);
export const FEATURES = features;